import BaseApiService from './baseApi';

class PartnerService extends BaseApiService {
  constructor() {
    super('/api/v1/partner/');
  }

  async getCompany(headers = {}) {
    return this.get('', {}, headers);
  }

  // Body cuma `enabled` — company, actor, source & timestamp ditentuin BE sendiri.
  async updateAdvisorConsent(enabled) {
    return this.put('advisor-consent', { enabled });
  }

  async find(email, phone, forParam = ''){
    if (forParam === '') {
      return this.post('find', { email, phone });
    }
    return this.post('find', { email, phone, for: forParam });
  }

  async findRevamp(email, phone, forParam){
    return this.post('skaix/find', { email: email, phone: phone, for: forParam });
  }

  async register(data) {
    return this.post('register', data);
  }

  async registerRevamp(data) {
    return this.post('skaix/register', data);
  }

  async registerUpdateRevamp(data) {
    return this.post('skaix/register/update', data);
  }

  async complete(data, headers = {}){
    return this.post('complete', data, headers);
  }
  
  async completeRevamp(data){
    return this.post('skaix/complete', data);
  }

  async validateBillingPartitaIva(partitaIva){
    return this.post('billing/validate', { partitaIva });
  }

  async validateVoucher(voucher){
    return this.get('voucher/' + voucher);
  }

  async subscribe(data){
    return this.post('subscribe', data);
  }

  // Renewal Monthly Service Fee (BE §2, endpoint terpisah dari subscribe — nol risiko setup fee).
  // Body: { packId, paymentMethod?, setupSucceeded? }. Response = shape SubscribeResponse
  // (finish / clientSecret / needSetup). State (grace/inactive) dicek server-side.
  async renew(data){
    return this.post('renew', data);
  }

  async platformMargin() {
    return this.get('platform/margins');
  }

  async setMargin(data) {
    return this.post('margin', data);
  }

  async customerList(data) {
    return this.post('customers', data);
  }

  async upload(data, headers = {}){
    return this.post('upload', data, headers);
  }

  async transactions(data){
    return this.post('transactions', data);
  }

  async voucherInsert(data){
    return this.post('voucher/insert', data);
  }

  async voucherBind(data){
    return this.post('skaix/voucher-bind', data);
  }

  async listShoppers(body) {
    return this.post('shoppers', body, {});
  }
  
  async findShopperByPhone(phone) {
    return this.get('transaction/shopper?phone=' + phone);
  }

  async receiptUpload(data){
    return this.post('transaction/receipt/upload', data);
  }

  async transactionManual(data) {
    return this.post('transaction/manual', data);
  }

  async uploadCover(data, headers = {}) {
    return this.put('upload-cover', data, headers);
  }
}

const partnerService = new PartnerService();

export default partnerService;